import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiCode,FiGrid,FiSparkles}=FiIcons;

function Dashboard({onOpenButtonGenerator}) {
  return (
    <main className="dashboard-shell">
      <header className="dashboard-topbar">
        <a className="dashboard-brand" href="#" aria-label="Shift Creative Tools home">
          <span className="dashboard-brand-mark"><SafeIcon icon={FiGrid} /></span>
          <span>shift<span>creative tools</span></span>
        </a>
        <span className="dashboard-top-note">A little workspace for big ideas</span>
      </header>
      <section className="dashboard-welcome">
        <div className="dashboard-eyebrow">YOUR CREATIVE WORKSPACE</div>
        <h1>Make something <span>good.</span></h1>
        <p>Small, focused tools to help bring your next idea to life.</p>
      </section>
      <section className="tools-section" aria-labelledby="tools-heading">
        <div className="tools-section-heading">
          <div>
            <span className="tools-kicker">THE TOOLKIT</span>
            <h2 id="tools-heading">Your tools</h2>
          </div>
          <span className="tools-count"><i />1 tool ready</span>
        </div>
        <button className="tool-card" type="button" onClick={onOpenButtonGenerator}>
          <span className="tool-icon"><SafeIcon icon={FiCode} /></span>
          <span className="tool-copy">
            <span className="tool-category">DESIGN TOOL</span>
            <strong>Button Generator</strong>
            <span>Create, style, and export a custom HTML button.</span>
          </span>
          <span className="tool-open" aria-hidden="true">
            <SafeIcon icon={FiArrowRight} />
          </span>
        </button>
        <div className="dashboard-next">
          <span className="next-icon"><SafeIcon icon={FiSparkles} /></span>
          <div>
            <strong>A growing creative toolkit</strong>
            <p>More handy tools will find their home here.</p>
          </div>
          <span className="next-label">COMING SOON</span>
        </div>
      </section>
      <footer className="dashboard-footer">
        <span>SHIFT CREATIVE TOOLS</span>
        <span>Make the shift.</span>
      </footer>
    </main>
  );
}

export default Dashboard;